export default {"gitHash":"f4feefe46bf6f0d944fe30242ef8e4de9e778eaf","gitHashShort":"f4feefe","time":1645071008135,"platform":"linux","arch":"x64"};